// Removes span elements with text content of a single space to prevent the bug after export
// (https://mysupport.chili-publish.com/hc/en-us/requests/15154?page=1)
const removeSeparateSpacesTextFlow = (textFlow: string): { wasModified: boolean; newTextFlow: string } => {
  let wasModified = false

  const parser = new DOMParser()
  const xml = parser.parseFromString(textFlow, 'application/xml')
  const ns = 'http://ns.adobe.com/textLayout/2008'

  const spans = Array.from(xml.getElementsByTagNameNS(ns, 'span'))

  for (let i = 0; i < spans.length; i++) {
    const span = spans[i]
    const text = span.textContent ?? ''

    if (text === ' ') {
      const parent = span.parentNode
      const prev = spans[i - 1]
      const next = spans[i + 1]

      if (prev && prev.parentNode === parent) {
        prev.textContent = (prev.textContent ?? '') + ' '
      } else if (next && next.parentNode === parent) {
        next.textContent = ' ' + (next.textContent ?? '')
      }

      parent?.removeChild(span)
      spans.splice(i, 1); // Remove from list without advancing

      wasModified = true
    }
  }

  if (!wasModified) {
    return {
      wasModified,
      newTextFlow: textFlow
    }
  }

  const serializer = new XMLSerializer()

  return {
    wasModified,
    newTextFlow: serializer.serializeToString(xml)
  }
}


export { removeSeparateSpacesTextFlow }
